/* eslint-disable max-len */
import 'react';

const SidebarLocalPPTSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="currentColor"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h16v16H0z" />
            <path
                d="M6.444 7.111h2.312a1.244 1.244 0 010 2.489H6.444h0v1.956"
                stroke="currentColor"
                strokeWidth={0.889}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="0,0"
            />
            <path
                d="M13.334 5.891v7.087c0 .687-.557 1.244-1.244 1.244H3.91a1.244 1.244 0 01-1.244-1.244V3.467c0-.688.557-1.245 1.244-1.245h5.825"
                stroke="currentColor"
                strokeWidth={0.889}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="0,0"
            />
            <path
                d="M13.333 5.778h-2.31a1.244 1.244 0 01-1.245-1.245v-2.31h0l3.555 3.555z"
                stroke="currentColor"
                strokeWidth={0.889}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="0,0"
            />
        </g>
    </svg>
);
export default SidebarLocalPPTSvg;
